import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cropper from "react-cropper";

import {
  editProfilePicture,
  getClientProfileData,
  editClientData,
  updateMeasurementSystem,
  editClientFieldData,
  getUserMeasurementData,
} from "./profileSlice";

import classes from "./Profile.module.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";

import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import DatePicker from "react-datepicker";
import "cropperjs/dist/cropper.css";
import { Form } from "react-bootstrap";
import useS3DirectUpload from '../../hooks/useS3DirectUpload'

import {setCurrentUser} from '../users/usersSlice'
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";

const ClientProfile = () => {
  const user = useSelector((state) => state.users.current_user);
  const dispatch = useDispatch();
  const statusDispatch = useApiStatusDispatch();
  const bioData = useSelector((state) => state?.users?.current_user?.bio_data)
  //Get client's data
  useEffect(() => {
    dispatch(getClientProfileData({ clientID: user.user_id_number }));
    dispatch(getUserMeasurementData());
  }, []);
  const clientData = useSelector((state) => state.profile.clientData[0]);
  const clientMeasurementSystem = useSelector(
    (state) => state.profile.clientMeasurementSystem
  );
  const measurementDataStatus = useSelector(
    (state) => state.profile.measurementDataStatus
  );

  //Client's state
  const [goalState, setGoalState] = useState("");
  const [likeState, setLikeState] = useState("");
  const [dislikeState, setDislikeState] = useState("");
  const [injuryState, setInjuryState] = useState("");

  //bio data state 
  const [height, setHeight] = useState('')
  const [heightUnits, setHeightUnits] = useState(0)
  const [weight, setWeight] = useState('')
  const [sex, setSex] = useState('')
  const [weightUnits, setWeightUnits] = useState(0)
  const [birthdate, setBirthdate] = useState('')
  useEffect(() => {
    if (clientData) {
      setGoalState(clientData.goals);
      setLikeState(clientData.likes);
      setDislikeState(clientData.dislikes);
      setInjuryState(clientData.injuries);
    }
  }, [clientData]);

  //error message handling
  const [showErrorMsg,setShowErrorMsg] =useState(false)
  const [errorMsg,setErrorMsg] =useState("")
  
  const [isLoginSaving, setIsLoginSaving] = useState(false);

  const {
    file:upload,
    processUpload,
    setUpload,
    clearUpload
  } = useS3DirectUpload()


  //Client Profile Pic
  const defaultPic = 'https://cdn.fitsw.com/assets/img/defaultProfile.png'
  const [clientProfilePic, setclientProfilePic] = useState("");
  useEffect(() => {
    setclientProfilePic(user?.profilePic);
    if ((user?.profilePic) === defaultPic || (user?.profilePic) === "") {
      setclientProfilePic(defaultPic)
    }
  }, [user]);

  useEffect(() => {
    if (!bioData) return
    let sexIds = ["1", "2", "3", "4"];
    let bioDataSexId = bioData.sex_id.toString();
    let sex = sexIds.includes(bioDataSexId) ? bioDataSexId : "1";
    setSex(sex)
    setHeight((bioData.height))
    setWeight((bioData.weight))
    setWeightUnits((bioData?.weight_units))
    setHeightUnits((bioData?.height_units))

    setBirthdate((
      bioData?.birthdate && (bioData?.birthdate !== '0000-00-00') ?
        new Date(bioData.birthdate.replace(/-/g, '\/')) :
        ''
    ))
  }, [bioData])


  // Bio Data Modal Variables 
  const [showBioData, setShowBioData] = useState(false);
  const handleBioDataClose = () => {
    setShowBioData(false)
  }

  const dateToAPIForm = date => (
    Boolean(date) ?
      //get YYYY-MM-DD HH:MM:SS from date object
      // mm/dd/yyy
      `${date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getDate()}` :
      ''
  )


  //Image Modal Variables
  const [showImgUpload, setShowImgUpload] = useState(false);
  const [uploadImg, setUploadImg] = useState("");
  const handleImgUploadClose = () => setShowImgUpload(false);
  // const handleImgUploadShow = () => setShowImgUpload(true);

  //Email Modal Variables
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const handleEmailModalClose = () => {
    setLoginEmail("");
    setShowEmailModal(false);
  };
  const handleEmailModalShow = (user_id) => {
    setLoginEmail(user_id);
    setShowEmailModal(true);
  };

  //Password Modal Variables
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordText, setPasswordText] = useState("");
  const handlePasswordModalClose = () => {
    setPasswordText("");
    setShowPasswordModal(false);
  };
  const handlePasswordModalShow = () => {
    setShowPasswordModal(true);
  };
  const [isPasswordSaving, setIsPasswordSaving] = useState(false);

  //Crop Variables
  const cropperRef = useRef(null);
  const croppedImgRef = useRef(null);
  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    cropper
      .getCroppedCanvas()
      .toBlob(async (blob) => {
        /* Add blob and file name */
        croppedImgRef.current = blob
      }, "image/jpeg")

  };

  const handleCropAndSave = async () => {
    //need to pass in the image directly rather than using the setUpload pattern
    //since doing so caused an infinite render loop
    const s3Res = await processUpload(
      await new File([croppedImgRef.current],`image.jpeg`,{type:"image/jpeg"})
    )
    if(s3Res.success){

      dispatch(
        editProfilePicture({
          action: "updateClientProfileData",
          field: "profilePic",
          value: "edit",
          new_profile_pic_url: s3Res.payload.url,
          using_s3: 1
        })
      )
      let updatedUser = JSON.parse(JSON.stringify(user))
      updatedUser.profilePic = URL.createObjectURL(croppedImgRef.current)
      dispatch(setCurrentUser(updatedUser)) 
      setclientProfilePic(URL.createObjectURL(croppedImgRef.current));
      handleImgUploadClose();
    }
  }

  //Measurement Unit
  const [measureUnit, setMeasureUnit] = useState("metric");
  useEffect(() => {
    setMeasureUnit(clientMeasurementSystem);
  }, [clientMeasurementSystem]);

  return (
    <div>
      {clientData ? (<>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={clientProfilePic}
            alt="User profile image"
            className={classes.ProfileImg}
          />
          <label className="btn btn-sm btn-light shadow-sm mt-2">
            Update Profile Photo
            <input
              type="file"
              hidden
              onChange={(e) => {
                setUploadImg(e.target.files[0]);
                setShowImgUpload(true);
              }}
              //Doing this to ensure that the onChange event fires even if the same file is selected
              onClick={(event) => {
                event.target.value = null;
              }}
            />
          </label>
        </div>

        <div className={[classes.SubHeaders, "mb-3"].join(" ")}>
          Login Email
        </div>
        <div className={["mb-3"].join(" ")}>
          {clientData.clientUserID}
        </div>
        <a
          style={{ cursor: "pointer", color: "#007bff" }}
          onClick={(e) => { e.preventDefault(); handleEmailModalShow(clientData.clientUserID) }}
        >
          Change Email
        </a>

        <div className={[classes.SubHeaders, "mb-3", "mt-5"].join(" ")}>
          Phone
        </div>
        <input
          className="form-control col-6 mb-5"
          // onChange={(e) => setPhoneNumber(e.target.value)}
          defaultValue={clientData?.clientPhone}
          onBlur={(e) =>
            dispatch(
              editClientFieldData({
                field: "phone",
                value: e.target.value,
              })
            )
          }
        />

        <div className={[classes.SubHeaders, "mb-3"].join(" ")}>
          Account Type
        </div>
        <div className={[classes.AccountTypeText].join(" ")}>
          Client Plan with Client ID Code{" "}
          <span
            style={{ textDecoration: "underline", fontWeight: "bold" }}
          >
            {user.user_id_number}
          </span>
        </div>

        <div className={[classes.SubHeaders, "mb-3"].join(" ")}>
          Password
        </div>
        <a
          style={{ cursor: "pointer", color: "#007bff" }}
          onClick={(e) => { e.preventDefault(); handlePasswordModalShow(); }}
        >
          Change Password
        </a>

        {/* Update Bio Date */}
        <div className={[classes.SubHeaders, "mt-5", "mb-3"].join(" ")}>
          Bio Data
        </div>
        <Form className="w-50">
          <Form.Group>
            <strong><label className="d-block">Date of Birth</label></strong>
            <DatePicker
              selected={birthdate}
              onChange={date => {
                setBirthdate(date)
                let apiBirthdate = dateToAPIForm(date).split(' ')[0];
                dispatch(editClientFieldData({ field: "bioData", value: apiBirthdate, question_type: "birthdate" }))
              }}
              dateFormat="MMM d, yyyy"
              showYearDropdown
              yearDropdownItemNumber={100}
              scrollableYearDropdown
              maxDate={new Date()}
              
          
            popperModifiers={{
              preventOverflow: {
                enabled: true,
                escapeWithReference: false,
                boundariesElement: 'viewport'
              }
              
            }}
            customInput={<Form.Control />}
            />
          </Form.Group>
          <Form.Group>
            <strong><label>Sex</label></strong>
            <Form.Control onChange={e =>
              setSex(e.target.value)}
              onBlur={() => {
                dispatch(editClientFieldData({ field: "bioData", value: sex, question_type: "sex_id" }))
              }}
              as="select" value={sex}>
              <option value="1">Not Selected</option>
              <option value="2">Male</option>
              <option value="3">Female</option>
              <option value="4">Other</option>
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <strong><label>Height </label></strong>
            <Row className="">
              <Col sm={9} className="pl-3 pr-0 m-0">
                <Form.Control
                  onChange={e => setHeight(e.target.value)} value={height}
                  onBlur={() => {
                    dispatch(editClientFieldData({ field: "bioData", value: height, question_type: "height" }))
                  }} />
              </Col>
              <Col sm={3} className="p-0 m-0">
                <Form.Control as="select"
                  onChange={e => setHeightUnits(e.target.value)} value={heightUnits}
                  onBlur={() => {
                    dispatch(editClientFieldData({ field: "bioData", value: heightUnits, question_type: "height_units" }))
                  }}>
                  <option value={0}>in</option>
                  <option value={1}>cm</option>
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group >
            <strong><label>Weight</label></strong>
            <Row className="">
              <Col sm={9} className="pl-3 pr-0 m-0">
                <Form.Control
                  onChange={e => setWeight(e.target.value)} value={weight}
                  onBlur={() => {
                    dispatch(editClientFieldData({ field: "bioData", value: weight, question_type: "weight" }))
                  }}
                />
              </Col>
              <Col sm={3} className="p-0 m-0">
                <Form.Control as="select"
                  onChange={e => setWeightUnits(e.target.value)} value={weightUnits}
                  onBlur={() => {
                    dispatch(editClientFieldData({ field: "bioData", value: weightUnits, question_type: "weight_units" }))
                  }}>
                  <option value={0}>lbs</option>
                  <option value={1}>kg</option>
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
        </Form>

        {/* Preferences */}
        <div className={classes.PreferenceHeader}><b>Preferences</b></div>
        <div
          class="form-group"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <label for="goal-form">Goals</label>
          <textarea
            value={goalState}
            onChange={(e) => setGoalState(e.target.value)}
            className="form-control col-8"
            id="goal-form"
            rows="3"
            onBlur={(e) => dispatch(editClientData({ goals: goalState }))}
          ></textarea>
        </div>

        <div
          class="form-group"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <label for="goal-form">Likes</label>
          <textarea
            value={likeState}
            onChange={(e) => setLikeState(e.target.value)}
            className="form-control col-8"
            id="goal-form"
            rows="3"
            onBlur={(e) => dispatch(editClientData({ likes: likeState }))}
          ></textarea>
        </div>

        <div
          class="form-group"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <label for="dislike-form">Dislikes</label>
          <textarea
            value={dislikeState}
            onChange={(e) => setDislikeState(e.target.value)}
            className="form-control col-8"
            id="dislike-form"
            rows="3"
            onBlur={(e) =>
              dispatch(editClientData({ dislikes: dislikeState }))
            }
          ></textarea>
        </div>

        <div
          class="form-group"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <label for="injuries-form">Injuries</label>
          <textarea
            value={injuryState}
            onChange={(e) => setInjuryState(e.target.value)}
            className="form-control col-8"
            id="injuries-form"
            rows="3"
            onBlur={(e) =>
              dispatch(editClientData({ injuries: injuryState }))
            }
          ></textarea>
        </div>

        <div
          class="form-group"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <label for="measurement-form">Measurement System</label>
          {measurementDataStatus == "idle" && (
            <select
              className="form-control col-8"
              id="measurement-form"
              onChange={(e) =>
                dispatch(
                  updateMeasurementSystem({ system: e.target.value })
                )
              }
            >
              <option value="metric" selected={measureUnit == "metric"}>
                Metric System
              </option>
              <option
                value="imperial"
                selected={measureUnit == "imperial"}
              >
                Imperial
              </option>
            </select>
          )}
        </div>

        <div style={{ margin: "20px", float: "right" }}>
          <i className="fas fa-info-circle"></i> Data is Automatically Saved
        </div>
      </>

      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            textAlign: "center",
          }}
        >
          <Spinner animation="border" role="status" variant="primary">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>

      )
      }


      {/* Bio Data */}
      <Modal
        show={showBioData}
        onHide={handleBioDataClose}
        animation={false}
      >
        <Modal.Header closeButton> <h1> Bio Data </h1></Modal.Header>
        <Modal.Body>

        </Modal.Body>
      </Modal>



      {/* Add Image Modal */}
      <Modal
        show={showImgUpload}
        onHide={handleImgUploadClose}
        animation={false}
        backdrop="static"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {/* <img src={URL.createObjectURL(uploadImg)} style={{width: "100%", marginTop: 20}}/> */}
          {uploadImg && (

            <Cropper
              zoomable={false}
              viewMode={2}
              autoCropArea={1}
              src={URL.createObjectURL(uploadImg)}
              // Cropper.js options
              guides={false}
              crop={onCrop}
              ref={cropperRef}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger mr-2"
            style={{ marginTop: 20, float: "right" }}
            onClick={handleImgUploadClose}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            style={{ marginTop: 20, float: "right" }}
            onClick={handleCropAndSave}
          >
            Crop and Save
          </Button>
          </Modal.Footer>
      </Modal>

      {/* Change Email Modal */}
      <Modal
        show={showEmailModal}
        onHide={handleEmailModalClose}
        animation={false}
      >
        <Modal.Header closeButton>Change Login Email</Modal.Header>
        <Modal.Body>
          <input
            className={["form-control"].join(" ")}
            onChange={(e) => setLoginEmail(e.target.value)}
            value={loginEmail}
          />
          <Button
            block
            disabled={isLoginSaving}
            onClick={(e) => {
              setIsLoginSaving(true)
              dispatch(editClientFieldData({field:'user_email',value:loginEmail}))
              statusDispatch(
                editClientFieldData(
                  { field: "user_id", value: loginEmail }
                ),"login email","update")
                .then((res) => {
                  setIsLoginSaving(false)
                  if(res.payload.success == '1'){
                    handleEmailModalClose();
                  } 
                  })
            }}
            className={classes.BlockButton}
          >
           {isLoginSaving ? <Spinner size="sm" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner> : "Update Login Email"}
          </Button>
          {showErrorMsg && 
            <p style={{color:'red'}}>{errorMsg}</p>
          }
        </Modal.Body>
      </Modal>

      {/* Change Password Modal */}
      <Modal
        show={showPasswordModal}
        onHide={handlePasswordModalClose}
        animation={false}
      >
        <Modal.Header closeButton>Change Password</Modal.Header>
        <Modal.Body>
          <input
            className={["form-control"].join(" ")}
            onChange={(e) => setPasswordText(e.target.value)}
            value={passwordText}
          />
          <Button
            disabled={passwordText=="" || isPasswordSaving }
            size="lg"
            block
            onClick={() => {
              setIsPasswordSaving(true)
              let payload = { clientPassword: passwordText, operation: 'changePassword' }
              statusDispatch(editClientData(payload),"password","update").then(
                res=> {
                  setIsPasswordSaving(false)
                  handlePasswordModalClose();
                }
              );
            }}
            size
            className={classes.BlockButton}
          >
            {isPasswordSaving ? <Spinner size="sm" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner> : "Update Password"}
          </Button>
        </Modal.Body>
      </Modal>
    </div >
  );
};

export default ClientProfile;
